import React from 'react';
import { Tooltip, Button } from '@mui/material';
import UILink from '@mui/material/Link';
import { OpsBrandNames } from '../../lib/utils';

const getBaseUrlForBrand = (brand = '', adminUrls = {}) => {
  const lowerCaseBrand = brand.toLowerCase();
  if (adminUrls[lowerCaseBrand]) {
    return adminUrls[lowerCaseBrand];
  }
};

function getUrl(brand, caseId, caseUrls) {
  let url = getBaseUrlForBrand(brand, caseUrls);
  if (url) {
    url += `${caseId}`;
    if (brand === OpsBrandNames.ZAGSTER) {
      url += '/view';
    }
    return url;
  }
}
function getDisplayId(brand, fieldReport) {
  switch (brand) {
    case OpsBrandNames.ZAGSTER:
      return fieldReport.sfCaseNumber;
    case OpsBrandNames.LINK:
      return fieldReport.caseId;
    default:
      return undefined;
  }
}

class CaseLinkButton extends React.Component {
  render() {
    const { fieldReport, caseUrls, asLink } = this.props;
    const {
      brand,
      caseId,
    } = fieldReport;

    const url = getUrl(brand, caseId, caseUrls);
    const displayId = getDisplayId(brand, fieldReport);
    if (displayId && url) {
      if (asLink) {
        return (
          <Tooltip title="Zendesk Link">
            <UILink
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(event) => event.stopPropagation()}
            >
              {displayId}
            </UILink>
          </Tooltip>
        );
      } else {
        return (
          <Tooltip title="Zendesk Link">
            <Button
              variant="outlined"
              color="primary"
              onClick={(event) => event.stopPropagation()}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginTop: '5px' }}
            >
              {displayId}
            </Button>
          </Tooltip>
        );
      }
    } else {
      return '';
    }
  }
}

export default CaseLinkButton;
